import React, { createContext, useCallback, useContext, useState } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./OrganizationDeleteDataUIHelpers";

const OrganizationDeleteDataUIContext = createContext();

export function useOrganizationDeleteDataUIContext() {
  return useContext(OrganizationDeleteDataUIContext);
}

export const OrganizationDeleteDataUIConsumer =
  OrganizationDeleteDataUIContext.Consumer;

export function OrganizationDeleteDataUIProvider({
  organizationDeleteDataUIEvents,
  children
}) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback(nextQueryParams => {
    setQueryParamsBase(prevQueryParams => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const initOrganizationDeleteData = {
    name: ""
  };

  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    initOrganizationDeleteData,
    openEditOrganizationDeleteDataPage:
      organizationDeleteDataUIEvents.openEditOrganizationDeleteDataPage
  };

  return (
    <OrganizationDeleteDataUIContext.Provider value={value}>
      {children}
    </OrganizationDeleteDataUIContext.Provider>
  );
}
